import Barcode from 'react-barcode';

interface BarcodeDisplayProps {
  value: string;
  /** Width of each bar (default 1.5) */
  width?: number;
  /** Height of the barcode bars in px (default 60) */
  height?: number;
  /** Show the text value below bars (default true) */
  displayValue?: boolean;
  className?: string;
}

/**
 * Renders a CODE128 barcode for the given value.
 * Use for any alphanumeric code (SKU, custom barcode, etc).
 */
export function BarcodeDisplay({
  value,
  width = 1.5,
  height = 60,
  displayValue = true,
  className,
}: BarcodeDisplayProps) {
  if (!value) return null;

  return (
    <div className={className}>
      <Barcode
        value={value}
        format="CODE128"
        width={width}
        height={height}
        displayValue={displayValue}
        fontSize={11}
        margin={4}
        background="transparent"
      />
    </div>
  );
}
